// App.js
import React from 'react';
import GanttChartApp from './page.jsx';
import Login from './components/LoginView/index.js';
import RegisterView from './components/RegisterView/index.js';
import ForgotPassword from './components/ForgotPassword/index.js';
import Header from './components/Header/index.js';
import MyPage from './components/MyPage/index.js';
import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.js';
import { SocketProvider } from './context/SocketContext.js';
import { Toaster } from 'react-hot-toast';

function App() {
  return (
    <div className="App" style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Toaster
        position="top-center"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#333',
            color: '#fff',
            fontSize: '14px',
            borderRadius: '8px',
            padding: '12px 20px',
          },
          success: { style: { background: '#16a34a' } },
          error: { style: { background: '#dc2626' } },
        }}
      />
      <AuthProvider>
        <SocketProvider>
          <Header />
          <Routes>
            <Route path="/" element={<GanttChartApp />} />
            <Route path="/Login" element={<Login />} />
            <Route path="/Register" element={<RegisterView />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/mypage" element={<MyPage />} />
            <Route path="/chart/:shareToken" element={<GanttChartApp />} />
          </Routes>
        </SocketProvider>
      </AuthProvider>
    </div>
  );
}

export default App;